import { PlannerConfigMarketDataEntity } from '@/services/configurator/PlannerConfigTypes';
import { listMarkets } from '@ingka-group-digital/pnv-shared';

export const sortedLocales = listMarkets().sort((a, b) => {
  const countryA = a.split('-')[1];
  const countryB = b.split('-')[1];
  return countryA.localeCompare(countryB);
});

export const allMarkets = sortedLocales.map((locale) => ({
  locale,
  isActive: false,
  productsInclude: [],
  productsExclude: [],
  rangeInclude: [],
  rangeExclude: [],
  imageUrl: '',
  videoUrl: '',
  primaryCardCtaUrl: '',
  secondaryCardCtaUrl: '',
  secondaryBannerImgUrl: '',
  secondaryBannerCtaUrl: '',
  includeDeeplinkParams: false,
}));

export function mergeWithDefaultMarkets(
  plannerMarketData?: PlannerConfigMarketDataEntity[] | null,
) {
  if (plannerMarketData) {
    return allMarkets.map((initialItem) => {
      const fetchedItem = plannerMarketData.find(
        (item) => item.locale === initialItem.locale,
      );

      return fetchedItem ? { ...initialItem, ...fetchedItem } : initialItem;
    });
  }
  return [];
}
